<template>
  <svg width="16" height="17" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(0 1)" stroke="#231F20" fill="none" fill-rule="evenodd">
      <path stroke-linecap="square" d="M.5 1.5h15M.5 7.5h15M.5 13.5h15" />
      <circle fill="#FFF" cx="4.5" cy="1.5" r="1.5" />
      <circle fill="#FFF" cx="11.5" cy="7.5" r="1.5" />
      <circle fill="#FFF" cx="5.5" cy="13.5" r="1.5" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconFilter',
};
</script>

<style></style>
